<template>
    <div class="paygo">
        <vrm-header></vrm-header>
        <vrm-title>
            <template v-slot:page-title>
                <h1 class="vrm-page-title">
                    {{ $t('paygo.installation.title', { i18nFallback: 'Current token' }) }}
                </h1>
                <span class="paygo-info">
                    {{
                        $t('paygo.installation.text', {
                            i18nFallback: 'Information regarding your currently active token',
                        })
                    }}
                </span>
            </template>
            <template v-slot:title-controls>
                <VrmStatus
                    class="paygo-header-block"
                    :realtime="false"
                    :time="installation.last_timestamp"
                    :offset="installation.timezone_offset_textual"
                    :alarm="installation.alarm"
                />
            </template>
            <!-- <template v-slot:mobile-page-title>
                <div class="paygo-cta hidden-sm hidden-md hidden-lg">
                    <div class="paygo-cta-title">
                        <span class="sg-vrm-icon_112_question_16px" />
                        Do you need assistance?
                    </div>
                    <div>Phone: +2453434343</div>
                    <div>Email: admin@gmail.com</div>
                </div>
                <br />
                <h1 class="vrm-page-title">Current token</h1>
                <span class="paygo-info">
                    Information regarding your currently active token
                </span>
            </template> -->
        </vrm-title>

        <div class="container">
            <token-info
                :is-active="isPaygoActive"
                :activation-date="paygoActivationDate"
                :total-days="totalDays"
                :token="tokenInfo"
                :is-paid="isPaid"
                :remaining-days="remainingDays"
                :no-token="noTokenInfo"
            />
            <div class="paygo-title-section">
                <!-- left side -->
                <div>
                    <h1 class="vrm-page-title">
                        {{
                            $t('paygo.installation.historyTitle', {
                                i18nFallback: 'Payment and token history',
                            })
                        }}
                    </h1>
                    <span>
                        {{
                            $t('paygo.installation.historyText', {
                                i18nFallback: 'An overview of your previews tokens and payments',
                            })
                        }}
                    </span>
                </div>
                <!-- <div class="paygo-cta hidden-xs">
                    <div class="paygo-cta-title">
                        <span class="sg-vrm-icon_112_question_16px" />
                        Do you need assistance?
                    </div>
                    <div>Phone: +2453434343</div>
                    <div>Email: admin@gmail.com</div>
                </div> -->
            </div>
            <br />
            <div v-for="yearTokens in tokenMap" :key="yearTokens.key" class="vrm-table__responsive">
                <div class="paygo-yaer-label">{{ yearTokens[0] }}</div>
                <vrm-scroll-fade>
                    <vrm-foldable-table :items="yearTokens[1]" key-by="idPaygoToken">
                        <template v-slot:thead>
                            <tr>
                                <th />
                                <th>
                                    {{ $t('paygo.installation.date', { i18nFallback: 'Date' }) }}
                                </th>
                                <th>
                                    {{
                                        $t('paygo.installation.amount', {
                                            i18nFallback: 'Payment amount',
                                        })
                                    }}
                                </th>
                                <th>
                                    {{
                                        $t('paygo.installation.token', {
                                            i18nFallback: 'Token code',
                                        })
                                    }}
                                </th>
                                <th />
                            </tr>
                        </template>
                        <template v-slot:main="{ item }">
                            <td>
                                {{ getDate(item.start) }}
                            </td>
                            <td>
                                {{ formatAmount(item.amount) }}
                            </td>
                            <td>
                                {{ item.code }}
                            </td>
                        </template>
                        <template v-slot:tfoot>
                            <tr v-if="false">
                                <td colspan="9999">
                                    {{
                                        $t('paygo.installation.noPayments', {
                                            i18nFallback: 'There are no payments so far',
                                        })
                                    }}
                                </td>
                            </tr>
                        </template>
                    </vrm-foldable-table>
                </vrm-scroll-fade>
            </div>
        </div>
    </div>
</template>
<script>
import { Vue, Component, Watch } from 'vue-property-decorator';
import { AngularRoute, ngInject } from '@/vue/decorators/angular-interop';
import VrmHeader from '@/vue/components/layout/VrmHeader';
import VrmTitle from '@/vue/components/layout/VrmTitle';
import VrmAvatar from '@/vue/components/shared/VrmAvatar';
import VrmToggle from '@/vue/components/shared/toggles/VrmToggle';

import VrmAvatarStack from '@/vue/components/shared/VrmAvatarStack';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import VrmFoldableTable from '@/vue/components/molecules/VrmFoldableTable';

import TokenInfo from './components/TokenInfo.vue';
import moment from 'moment';
import CurrencyMap from '@/utils/currency.js';
import VrmStatus from './../../../shared/VrmStatus.vue';

@Component({
    components: {
        VrmFoldableTable,
        VrmAvatarStack,
        VrmToggle,
        VrmAvatar,
        VrmHeader,
        TokenInfo,
        CurrencyMap,
        VrmStatus,
        VrmTitle,
    },
})
@AngularRoute('base.installation.settings.paygo', '/paygo', {
    slot: 'settings',
})
@AngularLocaleBundle('paygo')
export default class InstallationPaygo extends Vue {
    @ngInject()
    InstallationsService;
    @ngInject()
    ApiService;
    installation = null;
    tokens = [];
    tokenMap = new Map();

    get idSite() {
        return this.$route.params.id;
    }

    mounted() {
        this.ApiService.call(
            '/installations/' + this.idSite + '/paygo-tokens',
            {},
            'GET',
            false,
            'json',
            false,
        ).then(response => {
            this.tokens = response.data.paygoTokens;
            this.tokens.reverse();
            for (let i = 0; i < this.tokens.length; i++) {
                let year = new Date(this.tokens[i].start).getFullYear();
                if (!this.tokenMap.get(year)) this.tokenMap.set(year, []);
                this.tokenMap.get(year).push(this.tokens[i]);
            }
            this.tokenMap = new Map(Array.from(this.tokenMap).reverse());
        });
    }

    @Watch('idSite', { immediate: true })
    async loadSiteData() {
        if (!this.idSite) return;
        const idBefore = this.idSite;
        const installation = await this.InstallationsService.getInstallation(this.idSite);
        if (idBefore !== this.idSite) return;
        this.installation = installation;
    }

    getAttributeFromInstallationExtended(code) {
        return this.installation && this.installation.extended.find(item => item.code === code);
    }
    get paygoActivationDate() {
        const attribute = this.getAttributeFromInstallationExtended('pgaf');
        return attribute && moment.unix(attribute.rawValue).format('DD/MM/YYYY');
    }

    get totalDays() {
        const startDate = this.getAttributeFromInstallationExtended('pgaf');
        const endDate = this.getAttributeFromInstallationExtended('pgat');
        if (!startDate || !endDate) return null;
        return moment.unix(startDate.rawValue).diff(moment.unix(endDate.rawValue), 'days');
    }

    get remainingDays() {
        const activationDate = this.getAttributeFromInstallationExtended('pgaf');

        return activationDate && moment.unix(activationDate.rawValue).diff(moment(), 'days');
    }

    get noTokenInfo() {
        return (
            !this.getAttributeFromInstallationExtended('pgaf') ||
            !this.getAttributeFromInstallationExtended('pga')
        );
    }

    get tokenInfo() {
        const tokenValidity = this.getAttributeFromInstallationExtended('pglv');
        const tokenCode = this.getAttributeFromInstallationExtended('pglt');
        if (!tokenValidity) {
            return null;
        }
        if (!tokenCode) {
            return tokenValidity.formattedValue;
        }
        if (tokenValidity.rawValue === '1') {
            return tokenCode.rawValue;
        } else {
            return tokenValidity.formattedValue;
        }
    }

    get isPaygoActive() {
        const attribute = this.getAttributeFromInstallationExtended('pga');
        return attribute != undefined && attribute.rawValue == '1';
    }

    get isPaid() {
        if (!this.installation) return true;
        const totalAmount = this.installation.paygoTotalAmount;
        const totalPaid = this.totalPaid;
        return totalPaid >= totalAmount;
    }

    get totalPaid() {
        const tokens = this.tokens;
        let totalPaid = 0;
        for (let token of tokens) {
            if (token.isPaid) totalPaid += token.amount;
        }
        return totalPaid;
    }

    getDate(timeStamp) {
        let date = new Date(timeStamp);
        return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
    }
    formatAmount(amount) {
        return (
            (this.installation ? CurrencyMap[this.installation.paygoCurrency] : '') + ' ' + amount
        );
    }
}
</script>
